import React from 'react'
import { Box, Flex, Heading, Skeleton, Stack, Text } from '@chakra-ui/react'
import { LoadingStateProps } from '../types'

const LoadingState: React.FC<LoadingStateProps> = ({ subtitle, title }) => {
  return (
    <Box p={4}>
      <Flex direction="column" mb={6}>
        <Heading as="h1" size="xl">{title}</Heading>
        <Text color="gray.500">{subtitle}</Text>
      </Flex>
      
      <Stack spacing={6}>
        <Skeleton height="60px" />
        <Skeleton height="400px" />
        <Stack direction="row" spacing={4}>
          <Skeleton height="100px" width="100%" />
          <Skeleton height="100px" width="100%" />
          <Skeleton height="100px" width="100%" />
        </Stack>
        <Stack spacing={4}>
          <Skeleton height="80px" />
          <Skeleton height="80px" />
          <Skeleton height="80px" />
        </Stack>
      </Stack>
    </Box>
  )
}

export default LoadingState
